import { ClientInsuranceModel } from "@app/insurance";
import ServiceBase from "@app/shared/serviceBase";

export default class InsuranceService extends ServiceBase {
  // get all available insurances for the specified client or all insurances available to be assigned to a new client
  public async getAllInsurancesByClientId(clientId?: number): Promise<ClientInsuranceModel[]> {
    if (clientId) {
      return await this.makeGet<ClientInsuranceModel[]>(`insurances/client/${clientId}/available`);
    } else {
      return await this.makeGet<ClientInsuranceModel[]>(`insurances`);
    }
  }

  // get all authorized insurances for the specified client
  public async getAuthorizedInsurancesByClientId(clientId?: number): Promise<ClientInsuranceModel[]> {
    if (clientId) {
      return await this.makeGet<ClientInsuranceModel[]>(`insurances/client/${clientId}/authorized`);
    } else {
      return await this.makeGet<ClientInsuranceModel[]>(`insurances/authorized`);
    }
  }
}